export const REGISTER_OVERVIEW_BUTTONS_TEST_ID = "register-overview-buttons";
